<template>
    <div style="width: 100%">
        <AdminTools />
        <div class="flexContainer full what">
            <section id="sectionPrincipal">
                <section class="brand-list">
                    <section class="searchResultsWrapper">
                        <h1 class="headline uppercase">Properties Type</h1>
                        <section>
                            <div class="flexContainer ai-c jc-sb"><div class="flexContainer ai-c jc-sb"></div></div>
                            <hr class="full mt10 separator" />
                            <div v-for="property in properties" :key="property.id" class="listDisplay rel full flexContainer fd-c ai-c jc-fs">
                                <div class="listDisplay rel full flexContainer fd-c ai-c jc-fs list">
                                    <div class="listDisplay full ai-c jc-sb flexContainer">
                                        <div class="flexContainer fd-c size1of6">
                                            <span class="listTitle uppercase center">{{ property.name }}</span>
                                        </div>
                                        <div class="flexContainer fd-c size2of6">
                                            <ul v-for="brand in property.brandComponentPropertyTypes.map(bcpt => bcpt.brand)">
                                                <li>{{ brand.name }}</li>
                                            </ul>
                                        </div>
                                        <div class="flexContainer fd-c size2of6">
                                            <ul v-for="componentType in property.componentTypeComponentPropertyTypes.map(ctcpt => ctcpt.componentType)">
                                                <li>{{ componentType.name }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import TryLoad from "@/mixins/TryLoadMixin";
import componentService from "@/services/component";
import AdminTools from "../../adminTools/Admin";

export default {
    data: () => ({
        properties: [],
        loading: false
    }),
    components: {
        AdminTools
    },
    mixins: [TryLoad],
    async created() {
        this.properties = await this.tryLoad(() => componentService.getAllPropertiesType());
    }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// Properties.vue?7d05c404